/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications } from './JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications';
import {
    JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplicationsFromJSON,
    JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplicationsFromJSONTyped,
    JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplicationsToJSON,
} from './JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications';

/**
 * 
 * @export
 * @interface JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResult
 */
export interface JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResult {
    /**
     * 
     * @type {Array<JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications>}
     * @memberof JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResult
     */
    installedApplications?: Array<JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications>;
}

/**
 * Check if a given object implements the JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResult interface.
 */
export function instanceOfJumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResultFromJSON(json: any): JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResult {
    return JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResultFromJSONTyped(json, false);
}

export function JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'installedApplications': !exists(json, 'installedApplications') ? undefined : ((json['installedApplications'] as Array<any>).map(JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplicationsFromJSON)),
    };
}

export function JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResultToJSON(value?: JumboGetsentineloneagentsidinstalledapplicationsGetSentineloneAgentsIDInstalledApplicationsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'installedApplications': value.installedApplications === undefined ? undefined : ((value.installedApplications as Array<any>).map(JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplicationsToJSON)),
    };
}

